import * as yup from 'yup'
import { IntlShape } from 'react-intl'

export interface FormValues {
  firstName?: string
  lastName?: string
  email?: string
  currentPassword: string
  password: string
  passwordRetype: string
  editPassword: boolean
  editEmail: boolean
}
const PASSWORD_MIN_LENGTH = 8

export const validation = (
  intl: IntlShape
) => {
  const { formatMessage } = intl

  return (
    yup
      .object()
      .shape({
        email: yup
          .string()
          .email(formatMessage({ id: 'validation.emailValid' }))
          .when('editEmail', {
            is: (editEmail: boolean) => editEmail,
            then: yup.string()
              .required('Field is required')
          }),

        firstName: yup
          .string()
          .required(formatMessage({ id: 'validation.firstNameRequired' })),

        lastName: yup
          .string()
          .required(formatMessage({ id: 'validation.lastNameRequired' })),

        currentPassword: yup
          .string()
          .when('editEmail', {
            is: (editEmail: boolean) => editEmail,
            then: yup.string()
              .required('Field is required')
          })
          .when('editPassword', {
            is: (editPassword: boolean) => editPassword,
            then: yup.string()
              .required('Field is required')
          }),

        password: yup
          .string()
          .min(PASSWORD_MIN_LENGTH, formatMessage({ id: 'validation.passwordMinLength' }))
          .matches(/[a-z]/, formatMessage({ id: 'validation.passwordLowercase' }))
          .matches(/[A-Z]/, formatMessage({ id: 'validation.passwordUppercase' }))
          .matches(/[0-9]/, formatMessage({ id: 'validation.passwordNumbers' }))
          .when('editPassword', {
            is: (editPassword: boolean) => editPassword,
            then: yup.string()
              .required(formatMessage({ id: 'validation.passwordRequired' }))
          }),

        passwordRetype: yup
          .string()
          .when('password', (value: any, schema: any) => {
            if (value) {
              return schema.oneOf([
                yup
                  .ref('password')], 'Passwords must match')
                .required('Required')
            }
          })
      })
  )
}
